import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Terms from "./virtualtips/terms/Terms";
import Privacy from "./virtualtips/privacy/Privacy";
import Legal from "./virtualtips/legal/Legal";
import LandingDancerSelections from "./virtualtips/landing/LandingDancerSelections";
import LandingDancerPayoutBoard from "./virtualtips/landing/LandingDancerPayoutBoard";
import LandingSellVT from "./virtualtips/landing/LandingSellVT";
import LandingVenueSellVTHistory from "./virtualtips/landing/LandingVenueSellVTHistory";
import LandingAdminDashboardEdit from "./virtualtips/landing/LandingAdminDashboardEdit";
import LandingVenueTipHistory from "./virtualtips/landing/LandingVenueTipHistory";
import LandingVenueInvoiceDetails from "./virtualtips/landing/LandingVenueInvoiceDetails";
import App from "./App";
import LandingAdminDancerEdit from "./virtualtips/landing/LandingAdminDancerEdit";
import LandingAdminInvoices from "./virtualtips/landing/LandingAdminInvoices";
import SignupMobile from "./virtualtips/signup/mobile/SignupMobile";
import LoginMobile from "./virtualtips/login/mobile/LoginMobile";
import LandingSellDance from "./virtualtips/landing/LandingSellDance";
import LandingSellDrink from "./virtualtips/landing/LandingSellDrink";
import LandingVenueDanceHistory from "./virtualtips/landing/LandingVenueDanceHistory";
import LandingVenueDrinkHistory from "./virtualtips/landing/LandingVenueDrinkHistory";
import LandingStageDisplay from "./virtualtips/landing/LandingStageDisplay";
import LandingPreviousStage from "./virtualtips/landing/LandingPreviousStage";
import {Auth0Provider} from "@auth0/auth0-react";
import LandingAdminDashboard from "./virtualtips/landing/LandingAdminDashboard";
import LandingDancerCheckin from "./virtualtips/landing/LandingDancerCheckin";
import LandingMarketing2 from "./virtualtips/landing/LandingMarketing2";
import MuiThemeBridge from "./virtualtips/theme/MuiThemeBridge";

const root = ReactDOM.createRoot(document.getElementById('root'));
const domain = "dev-16yp2zuajbsdubke.us.auth0.com";

root.render(
    <Auth0Provider
        domain="dev-16yp2zuajbsdubke.us.auth0.com"
        clientId="tiadoef0prmye9BJX9IfnGfQGKtXiJiA"
        useRefreshTokens={true}
        cacheLocation="localstorage"
        authorizationParams={{
            redirect_uri: window.location.origin,
            audience: 'https://virtualtipzaudience',
            scope: "openid profile email offline_access"
        }}
    >
        <MuiThemeBridge>
            <BrowserRouter>
                <Routes>

                    {/*/!*RichestIn*!/*/}
                    {/*<Route path="/richestin" element={<LandingHome/>}/>*/}


                    {/*/!*Payments*!/*/}
                    {/*<Route path="/checkout" element={<LandingFormCheckoutVT/>}/>*/}
                    {/*<Route path="/checkout/success" element={<LandingStripePaymentSuccess/>}/>*/}

                    {/*User*/}
                    <Route path="/" element={<App/>}/>
                    {/*<Route path="/find" element={<LandingFindClub/>}/>*/}
                    {/*<Route path="/stage" element={<LandingStage/>}/>*/}

                    {/*<Route path="/user/buy" element={<LandingBuyVT/>}/>*/}
                    {/*<Route path="/user/buy/history" element={<LandingUserBuyVTHistory/>}/>*/}
                    {/*<Route path="/user/tip/history" element={<LandingUserTipHistory/>}/>*/}
                    {/*<Route path="/user/dance/history" element={<LandingUserDanceHistory/>}/>*/}
                    {/*<Route path="/user/drink/history" element={<LandingUserDrinkHistory/>}/>*/}
                    {/*<Route path="/user/code" element={<LandingUserCode/>}/>*/}
                    {/*<Route path="/user/rewards" element={<LandingUserRewards/>}/>*/}


                    {/*Admin Dashboard*/}
                    <Route path="/venue/dashboard" element={<LandingAdminDashboard/>}/>
                    <Route path="/venue/edit" element={<LandingAdminDashboardEdit/>}/>
                    <Route path="/venue/invoice/details" element={<LandingVenueInvoiceDetails/>}/>
                    <Route path="/venue/sell/history" element={<LandingVenueSellVTHistory/>}/>
                    <Route path="/venue/tip/history" element={<LandingVenueTipHistory/>}/>
                    <Route path="/venue/dance/history" element={<LandingVenueDanceHistory/>}/>
                    <Route path="/venue/drink/history" element={<LandingVenueDrinkHistory/>}/>
                    <Route path="/stage/display" element={<LandingStageDisplay/>}/>
                    <Route path="/stage/previous" element={<LandingPreviousStage/>}/>

                    {/*Sell*/}
                    <Route path="/sell" element={<LandingSellVT/>}/>
                    <Route path="/dance/sell" element={<LandingSellDance/>}/>
                    <Route path="/drink/sell" element={<LandingSellDrink/>}/>

                    {/*Dancer Checkin*/}
                    <Route path="/dancer/checkin" element={<LandingDancerCheckin/>}/>

                    {/*Moderator*/}
                    <Route path="/selection" element={<LandingDancerSelections/>}/>

                    {/*Payout*/}
                    <Route path="/payout" element={<LandingDancerPayoutBoard/>}/>

                    {/*PayInvoice*/}
                    <Route path="/venue/invoice" element={<LandingAdminInvoices/>}/>

                    {/*EditDancer*/}
                    <Route path="/venue/dancer/edit" element={<LandingAdminDancerEdit/>}/>


                    {/*/!*DancePay*!/*/}
                    {/*<Route path="/dance/buy" element={<LandingBuyDance/>}/>*/}

                    {/*/!*DrinkPay*!/*/}
                    {/*<Route path="/drink/buy" element={<LandingBuyDrink/>}/>*/}

                    {/*Marketing — public, does NOT require authentication (renders directly, not through App) */}
                    <Route path="/marketing" element={<LandingMarketing2/>}/>

                    {/*Other*/}
                    {/*<Route path="/dancer" element={<DancerDashboardLogin/>}/>*/}
                    {/*<Route path="/admin" element={<LoginVenueUser/>}/>*/}
                    {/*<Route path="/signup" element={<Signup/>}/>*/}
                    <Route path="/signup/mobile" element={<SignupMobile/>}/>
                    {/*<Route path="/login" element={<LoginOnboard/>}/>*/}
                    {/*<Route path="/login/mobile" element={<LoginMobile/>}/>*/}
                    <Route path="/login/mobile" element={<LoginMobile/>}/>

                    {/*<Route path="/login/forgot" element={<ForgotPassword/>}/>*/}
                    {/*<Route path="/admin/forgot" element={<ForgotPasswordVenue/>}/>*/}
                    {/*<Route path="/resetpassword" element={<ResetPassword/>}/>*/}
                    {/*<Route path="/validateemail" element={<ValidateEmail/>}/>*/}
                    {/*<Route path="/validatemobile" element={<ValidateMobile/>}/>*/}
                    <Route path="/terms" element={<Terms/>}/>
                    <Route path="/privacy" element={<Privacy/>}/>
                    <Route path="/legal" element={<Legal/>}/>
                    <Route
                        path="*"
                        element={
                            // <ComingSoon/>
                            <App/>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </MuiThemeBridge>
    </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
